<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <span :class="{'has-error':errors.source}">
        <select name="source" :value="source" class="form-control" @change="handleChange">
          <option value="" selected="selected">
            Select a Source
          </option>
          <option v-for="(source, $id) in config.deviceSources" :value="source.id">
            {{ source.name }}
          </option>
        </select>
      </span>
      last datum was
      <span :class="{'has-error':errors.operator}">
        <select name="operator" :value="operator" class="form-control" @change="handleChange">
          <option value="gte">
            more
          </option>
          <option value="lt">
            less
          </option>
        </select>
        than
      </span>
      <span :class="{'has-error':errors.amount}">
        <input
            :value="amount"
            class="form-control input-numeric"
            name="amount"
            @input="handleChange"
        >
        hours ago
      </span>
    </div>
    <div class="alert alert-warning">This is an experimental condition which may have some timezone/compatibility issues for some devices.</div>
  </div>
</template>
<script type="text/javascript">
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

export default {
  extends: BaseComponent,

  props: {
    source: [Number, String],
    operator: {type: String, default: 'gte'},
    amount: [Number, String],
    id: String
  },
  methods: {
    validate: function() {
      this.errors = {};

      if (!this.source) {
        this.errors.source = 'Please select a source.';
      }

      if (!this.operator) {
        this.errors.operator = 'Please select an operator.';
      }

      if (!this.amount) {
        this.errors.amount = 'Please enter a time window.';
      } else if (!this.isInteger(this.amount) || this.amount < 1) {
        this.errors.amount = "Time window must be a positive integer"
      }

      return Object.keys(this.errors).length === 0;
    }
  }
};
</script>
